import { ColorInterface } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../../services/sblib.service';
import { ToolsService } from '../../services/tools.service';
import { ColorInterfaceTemplate } from '../templates/models/colorinterfacetemplate.model';


@Component({
  selector: 'app-color-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CustomComponent implements OnInit, OnDestroy {
  @Input() custom_colors: ColorInterface;
  @Input() template?: boolean;

  @Output() onTemplateUpdate = new EventEmitter<ColorInterface>();
  @Output() onTemplateCreate = new EventEmitter<ColorInterfaceTemplate>();
  @Output() onTemplateDestroy = new EventEmitter<boolean>();

  public uploading: boolean = false;
  public deleting: boolean = false;
  public createNewTemplate: ColorInterfaceTemplate = {
    name: '',
    values: null
  };

  public subscriptions: Array<Subscription>;
  
  constructor(private sblibService: SblibService, private toolsService: ToolsService, private toastrService: ToastrService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  public applyCustomStyles(){
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      res.color.manual = JSON.parse(JSON.stringify(this.custom_colors));
      this.sblibService.apply(res);
      this.toastrService.success("","Success")
    });
    this.subscriptions.push(tools$);
  }

  public udpdateTemplate(templateValues: ColorInterface) {
    this.uploading = true;
    this.onTemplateUpdate.emit(templateValues);
  }

  public createTemplate(templateValues: ColorInterfaceTemplate){
    this.onTemplateCreate.emit(templateValues);
  }

  public destroyTemplate(){
    this.onTemplateDestroy.emit()
  }
}
